import styled from "styled-components/macro";

const $StepbarContainer = styled.div`
  height: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`;

interface StepPropsType {
  $completed: boolean;
}

const $Step = styled.div<StepPropsType>`
  border-radius: 0.25rem;
  border: solid 2px;

  ${({ theme, $completed }) => [
    `background-color: ${
      $completed ? theme.ColorMint500 : theme.ColorBlurple100
    };
    border-color: ${$completed ? theme.ColorMint500 : theme.ColorBlurple100};
    `,
  ]}

  height: 100%;
  flex-grow: 1;
  margin-left: 0.5rem;
`;

interface StepbarProps {
  currentStep: number;
  totalSteps: number;
}

export default function Stepbar({ currentStep, totalSteps }: StepbarProps) {
  const steps = [];

  for (let idx = 0; idx < totalSteps; idx++) {
    const completed = idx < currentStep;
    steps.push(<$Step $completed={completed} key={idx} />);
  }

  return (
    <$StepbarContainer>
      <span className="visually-hidden">
        Step {currentStep} of {totalSteps}
      </span>
      {steps}
    </$StepbarContainer>
  );
}
